import { useEffect, useState } from 'react';
import GuardTable from '../../components/GuardTable';
import { portalApi } from '../../services/portalApi';
import type { Guard } from '../../types';

function sortGuards(guards: Guard[]): Guard[] {
  return [...guards].sort((a, b) => {
    if (a.is_active !== b.is_active) return a.is_active ? -1 : 1;
    return a.display_name.localeCompare(b.display_name);
  });
}

export default function TrusteeGuards() {
  const [guards, setGuards] = useState<Guard[]>([]);
  const [loading, setLoading] = useState(true);
  const [activeGuardIds, setActiveGuardIds] = useState<Set<string>>(new Set());
  const [nameFilter, setNameFilter] = useState('');

  useEffect(() => {
    Promise.all([
      portalApi.listGuards(),
      portalApi.activeSessions().catch(() => []),
    ]).then(([gs, sessions]) => {
      setGuards(gs);
      setActiveGuardIds(new Set(sessions.map((s) => s.guard_id)));
    }).finally(() => setLoading(false));
  }, []);

  const filtered = sortGuards(
    guards.filter((g) =>
      !nameFilter || g.display_name.toLowerCase().includes(nameFilter.toLowerCase()),
    ),
  );

  return (
    <div className="px-6 py-6 max-w-4xl">
      <div className="mb-4">
        <h1 className="text-lg font-semibold text-gray-900">Patrollers</h1>
        <p className="text-sm text-gray-500">
          {guards.length} patroller{guards.length !== 1 ? 's' : ''}
          {activeGuardIds.size > 0 && (
            <span className="ml-1 text-green-600">· {activeGuardIds.size} on patrol</span>
          )}
        </p>
      </div>
      <div className="mb-4">
        <input
          type="text"
          placeholder="Filter by name…"
          value={nameFilter}
          onChange={(e) => setNameFilter(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 w-64"
        />
      </div>
      <div className="bg-white rounded-xl border border-gray-200 p-4">
        <GuardTable
          guards={filtered}
          activeGuardIds={activeGuardIds}
          loading={loading}
          readOnly
        />
      </div>
    </div>
  );
}
